/**
 * Main entrypoint for scripts of this website.
 *
 * @constructor
 */
function Website() {
    const self = this;

    const ccm19Trigger = document.querySelectorAll('.ccm19-dialog-trigger');
    if (ccm19Trigger) {
        ccm19Trigger.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                CCM.openWidget();
                return false;
            })
        });
    }

    this.loaderHtml = '<div class="loading-animation-container d-flex justify-content-center">' +
        '<div class="spinner-border" role="status">' +
        '<span class="sr-only">Loading...</span>' +
        '</div>' +
        '</div>';

    this.loaderHtmlWizard = '<div class="loading-animation-container loading-wizard">' +
        '<div class="placeholder step"></div>' +
        '<div class="placeholder step"></div>' +
        '<div class="placeholder step"></div>' +
        '<div class="placeholder step"></div>' +
        '<div class="buttons">' +
        '<div class="placeholder button"></div>' +
        '<div class="placeholder button"></div>' +
        '</div>' +
        '</div>';

    // Current browser dimensions
    this.browserDimensions = GeneralUtility.getBrowserDimensions();

    // Main HTML tag
    this.html = document.querySelector('html');

    // Main body tag
    this.body = document.querySelector('body');

    // Main website header
    this.header = document.querySelector('header');

    // Main content section
    this.main = document.querySelector('main');

    // Main website footer
    this.footer = document.querySelector('footer');

    this.requestUserInfo();
    this.initializeTouch();
    this.initializePlugins();
    this.initializeContentElements();
    this.initializeExtensions();
    this.scrollToAnchor();
    this.initializeBootstrapComponents();

    if (this.body.querySelector('.btn-print')) {
        this.body.querySelector('.btn-print').addEventListener('click', function () {
            window.print();
        })
    }

    //redirect user to start page if login expired
    /*setInterval(function() {
        GeneralUtility.ajaxGetRequest(GeneralUtility.getAjaxUrl('user-info'), function(data) {
            if(data) {
                var userData = JSON.parse(data);
                if(!userData['username']) {
                    document.location.href = '/';
                }
            } else {
                document.location.href = '/';
            }
        });
    }, 60000);*/

}

/**
 * Initializes bootstrap components (needed for AJAX content)
 *
 * @returns {void}
 */
Website.prototype.initializeBootstrapComponents = function () {

    document.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
        new Tooltip(tooltip);
    });
    document.querySelectorAll('[data-toggle="collapse"]').forEach(function (collapse) {
        new Collapse(collapse);
    });

};


/**
 * Requests user info to be shown in the top right corner
 *
 * @returns {void}
 */
Website.prototype.requestUserInfo = function () {
    GeneralUtility.ajaxGetRequest(GeneralUtility.getAjaxUrl('user-info'), function (data) {
        if (data) {
            var userData = JSON.parse(data);
            document.querySelectorAll('[data-type="user"]').forEach(function (item) {
                var property = item.dataset.property;

                if (property && userData[property]) {
                    item.innerHTML = userData[property];
                }
            });
        }
    });
};

/**
 * Scroll to anchor if given
 *
 * @returns {void}
 */
Website.prototype.scrollToAnchor = function () {
    if (window.location.hash) {
        var hash = window.location.hash;
        var element = document.querySelector(hash);
        if (element) {
            scrollTop = window.pageYOffset + element.getBoundingClientRect().top;
        }

    }
};

/**
 * Initialize touch functionality.
 *
 * @returns {void}
 */
Website.prototype.initializeTouch = function () {
    if (GeneralUtility.isTouch()) {
        document.body.classList.add('is-touch');
    } else {
        document.body.classList.add('no-touch');
    }
};

/**
 * Initializes plugins of this sitepackage.
 *
 * @returns {void}
 */
Website.prototype.initializePlugins = function () {
    var reservationContainers = this.body.querySelectorAll('[data-plugin="reservation"]');
    if (reservationContainers) {
        var reservationPlugin = new Sitepackage.Plugin.Reservation(reservationContainers);
    }
    var notificationContainers = this.body.querySelectorAll('[data-plugin="notification"]');
    if (notificationContainers) {
        var notificationPlugin = new Sitepackage.Plugin.Notification(notificationContainers);
    }
};

/**
 * Initializes content elements of this sitepackage.
 *
 * @returns {void}
 */
Website.prototype.initializeContentElements = function () {
    this.initializeVideos();
};

/**
 * Initializes other TYPO3 extensions..
 *
 * @returns {void}
 */
Website.prototype.initializeExtensions = function () {

};

Website.prototype.initializeVideos = function () {
    var videoContainers = this.body.querySelectorAll('.video-container');

    videoContainers.forEach(function (item) {
        var videoContainer = item;

        var playButton = videoContainer.querySelector('.play');
        if (!playButton) {
            return;
        }

        // Create video iFrame
        var source = playButton.dataset.source;
        var type = playButton.dataset.type;
        var videoPlayer = playButton.nextSibling;

        // Get video ID
        if (type === 'vimeo') {
            var videoId = source.split('/');
            videoId = videoId.pop();

            // Create iFrame on click
            var preview = videoPlayer.find('video');
            playButton.addEventListener('click', function (e) {
                videoContainer.classList.add('playing');
                playButton.style.display = 'none';
                preview.classList.add('hide');
                videoPlayer.innerHTML += '<iframe src="https://player.vimeo.com/video/' + videoId + '?title=0&byline=0&portrait=0&autoplay=1"' +
                    'class="h-100 w-100" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" allow="autoplay; fullscreen" />';
            });
        } else {
            var videoId = source.split('watch?v=');
            if (videoId.length === 2 && videoId[1]) {
                videoId = videoId[1];

                // If there is no preview video, create preview image
                var preview = videoPlayer.querySelector('video');
                if (preview.length === 0) {
                    var src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
                    videoPlayer.style.backgroundImage = 'url(' + src + ')';

                    videoPlayer.innerHTML += '<img src="' + src + '" class="preview invisible" />';
                }

                // Create iFrame on click
                playButton.addEventListener('click', function (e) {
                    videoContainer.classList.add('playing');
                    playButton.style.display = 'none';
                    preview.classList.add('hide');
                    videoPlayer.innerHTML += '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1"' +
                        'class="h-100 w-100" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" allow="autoplay; fullscreen" />';
                });
            }
        }
    });

}

var website;
document.addEventListener('DOMContentLoaded', function (e) {
    website = new Website();

    GeneralUtility.initializeDropdownSearch();

    document.querySelectorAll('button.btn-voucher, a.btn-voucher').forEach(function (item) {
        item.addEventListener('click', function (e) {
            var uid = e.target.dataset.uid;
            if (!uid) {
                var el = e.target.closest('button.btn-voucher, a.btn-voucher');
                uid = el.dataset.uid;
            }
            //Set downloaded status for each row belonging to this reservation
            document.querySelectorAll('.btn-voucher[data-uid="' + uid + '"]').forEach(function (item) {
                item.classList.add('downloaded');
                item.querySelector('.trigger').classList.add('drawn');
            });
        });
    });

    //Remove focus on save button after animation completed
    var disabledButtons = document.querySelectorAll('.btn.disabled, .btn:disabled');
    if (disabledButtons) {
        disabledButtons.forEach(function (item) {
            item.addEventListener('click', function (e) {
                var button = this;
                setTimeout(function () {
                    button.blur();
                }, 1000);

            });
        })

    }

    //Remove focus on dropdown toggle button if dropdown was closed
    var dropdowns = document.querySelectorAll('.dropdown');
    if (dropdowns) {
        dropdowns.forEach(function (item) {

            // hide.bs.dropdown
            item.addEventListener('hide.bs.dropdown', function (event) {
                setTimeout(function () {
                    item.querySelector('.btn-dropdown').blur();
                }, 100);
            }, false);

        });
    }


    document.querySelector('#nav-icon-container, #nav-icon, .menu-text').addEventListener('click', function (e) {
        website.body.classList.add('menu-open');
        document.getElementById('menu-container').classList.add('open');
    });
    document.getElementById('nav-icon-container').addEventListener('click', function (e) {
        website.body.classList.add('menu-open');
        document.getElementById('menu-container').classList.add('open');
    });
    document.getElementById('nav-icon-close').addEventListener('click', function (e) {
        website.body.classList.remove('menu-open');
        document.getElementById('menu-container').classList.remove('open');
    });

    //Close menu if it is open and user clicks outside
    document.addEventListener('click', function (e) {
        if (website.body.classList.contains('menu-open') && !e.target.closest('#menu-container') && !e.target.closest('#nav-icon-container')) {
            website.body.classList.remove('menu-open');
            document.getElementById('menu-container').classList.remove('open');
        }

    });

    // Klick auf das Suche-Icon öffnet das Suche Inputfeld.
    var searchForm = document.getElementById('search-filter');
    if (searchForm) {
        document.querySelectorAll('.icon-search').forEach(function (item) {
            item.addEventListener('click', function (e) {
                searchForm.querySelector('input').focus();
            });
        });

        var backSpaceIcon = searchForm.querySelector('.icon-remove');
        if (backSpaceIcon) {
            backSpaceIcon.addEventListener('click', function () {
                searchForm.querySelector('input').value = '';
                searchForm.submit();
            });
        }
    }

    // Notifications-Dropdown bleibt geöffnet, wenn ein Toast geschlossen wird.
    document.querySelectorAll('.notifications-dropdown').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    });

    document.querySelectorAll('.modal').forEach(function (modal) {
        modal.addEventListener('show.bs.modal', function () {
            var modalBody = modal.querySelector('.modal-body');


            if (modalBody.dataset.load === 'wizard') {

                //Hide submit buttons. Show again after action is initialized
                modal.querySelector('.modal-footer').classList.add('d-none');

                var modalTitle = document.getElementById('modal-reservation-title');
                modalTitle.classList.add('d-none');
                modalBody.innerHTML = website.loaderHtmlWizard;
                var url = GeneralUtility.getAjaxUrl('wizard');
                if (modalBody.dataset.reservationid) {
                    url = GeneralUtility.appendUrlParameter(url, 'reservationId', parseInt(modalBody.dataset.reservationid));
                }
                GeneralUtility.ajaxGetRequest(url, function (data) {
                    modalBody.innerHTML += data;
                    website.initializePlugins();
                });
            } else if (modalBody.dataset.load === 'showcode') {
                var modalTitle = document.getElementById('modal-reservation-code-title');
                modalTitle.classList.add('d-none');
                modalBody.innerHTML = website.loaderHtml;
                var url = GeneralUtility.getAjaxUrl('show-code');
                if (modalBody.dataset.reservationid) {
                    url = GeneralUtility.appendUrlParameter(url, 'reservationId', parseInt(modalBody.dataset.reservationid));
                }
                GeneralUtility.ajaxGetRequest(url, function (data) {
                    modalBody.innerHTML = data;
                    website.initializePlugins();
                });
            }
        });
    });

    document.querySelectorAll('.collapse').forEach(function (collapse) {
        collapse.addEventListener('show.bs.collapse', function () {
            this.closest('.card').classList.add('card-active');
        });
        collapse.addEventListener('hide.bs.collapse', function () {
            this.closest('.card').classList.remove('card-active');
        });
    });
});

